import { stringify } from 'qs';
import { Platform } from 'react-native';
export const FrontEndHostMap = [
    'https://rn-activity.test.gifshow.com',
    'https://rn-activity-preonline.test.gifshow.com',
    'https://share.kwaiying.com/rn-activity',
    'https://rn-activity.staging.kuaishou.com',
];
function getWebUrl(bundle, component, params, env) {
    const pathname = window?.location?.pathname || '';
    const index = pathname.indexOf(`/${bundle}`);
    let path = `/${component}.html`;
    if (env !== undefined) {
        path = `/${bundle}` + path;
    }
    else {
        if (index > -1) {
            path = pathname.substring(0, index) + `/${bundle}` + path;
        }
        if (pathname.startsWith('/rn-activity')) {
            path = '/rn-activity' + path;
        }
    }
    if (params) {
        path += `?${stringify(params)}`;
    }
    const host = FrontEndHostMap[env || -1] ||
        (Platform.OS === 'web' ? window.location.origin : FrontEndHostMap[2]);
    return host + path;
}
export default function getUrl(bundle, component, params, platform, env, withDegradeWebUrl = false) {
    if (platform === 'rn' || (Platform.OS !== 'web' && platform !== 'web')) {
        let scheme = `${process.env.APP || 'kwaiying'}://krn?bundleId=${bundle}&componentName=${component}`;
        if (params) {
            scheme += `&${stringify(params)}`;
        }
        if (withDegradeWebUrl) {
            scheme += `&degradeWebUrl=${encodeURIComponent(getWebUrl(bundle, component, params, env))}`;
        }
        return scheme;
    }
    else {
        return getWebUrl(bundle, component, params, env);
    }
}
